import { RoleModel } from "../../entities";
import { BaseODataRepository } from "../BaseODataRepository";

export class RoleODataRepo extends BaseODataRepository<RoleModel> {
  protected baseUrl = `/OData/roles`;
}